import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Icon } from '@iconify/react';

import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

/** Normalize legacy "fa-solid fa-name" → Iconify "fa6-solid:name" */
export function normalizeIconifyName(icon) {
  if (typeof icon !== 'string') return icon;
  const raw = icon.trim();
  if (!raw) return raw;

  // "fa-solid:graduation-cap" (must run before generic "has colon" pass-through)
  const colonSolid = raw.match(/^fa-solid:(.+)$/i);
  if (colonSolid) return `fa6-solid:${colonSolid[1]}`;

  // "fa-solid fa-graduation-cap" | "fa6-solid fa-users"
  const spaced = raw.match(/^fa(?:6)?-solid\s+fa-(.+)$/i);
  if (spaced) return `fa6-solid:${spaced[1]}`;

  // "fas fa-x" (older)
  const fas = raw.match(/^fas\s+fa-(.+)$/i);
  if (fas) return `fa6-solid:${fas[1]}`;

  // Already Iconify-style (mdi:home, fa6-solid:users, …)
  if (raw.includes(':') && !/\s/.test(raw)) return raw;

  return raw;
}

const Iconify = forwardRef(({ icon, width = 20, sx, ...other }, ref) => (
  <Box
    ref={ref}
    component={Icon}
    className="component-iconify"
    icon={normalizeIconifyName(icon)}
    sx={{ width, height: width, ...sx }}
    {...other}
  />
));

Iconify.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
  width: PropTypes.number,
};

export default Iconify;
